import moment from "moment";

export const defaultExcludedKeys = [
  'id', 'revision', 'refundNumber', 'amount', 'revisionType', 'createdBy', 'createdOn', 'updatedBy', 'updatedOn', 'isDeleted'
];

export const formatAndConcatenateValues = (obj, excludedKeys = defaultExcludedKeys) => {

  const handleValue = (value) => {
    if (value == null || value === "" || typeof value === "boolean") return "";

    if (Array.isArray(value)) {
      return value
        .map(item => handleValue(item))
        .filter(v => v)
        .join(", ");
    }

    if (typeof value === "object") {
      if (value.level && value.roleCode !== undefined) {
        return `${value.level}-${value.roleCode}`;
      }

      if (value.label) return value.label;

      return Object.entries(value)
        .filter(([key]) => !excludedKeys.includes(key))
        .map(([_, v]) => handleValue(v))
        .filter(v => v)
        .join(" ");
    }

    return String(value);
  };

  return Object.entries(obj)
    .filter(([key]) => !excludedKeys.includes(key))
    .map(([_, v]) => handleValue(v))
    .filter(v => v)
    .join(", ");
};
